import { render, staticRenderFns } from "./InboxPage.vue?vue&type=template&id=781d9cc4"
import script from "./InboxPage.vue?vue&type=script&lang=js"
export * from "./InboxPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports